import { ExpressionRuleEditor } from "../ExpressionRuleEditor";
import { BracketedDiv, ExpressionPiece } from "../../Builder/ExpressionStyles";
import { ExpressionValueRenderer } from "../../Builder/ExpressionValueRenderer";
import React from "react";
import { StringIsValidEmailExpression } from "../../../rule-engine-core/Expressions/Expressions/String/StringIsValidEmailExpression";

export class StringIsValidEmailExpressionEditor extends ExpressionRuleEditor<StringIsValidEmailExpression> {
    render() {
        return (
            <>
                <ExpressionPiece>
                    <BracketedDiv>
                        <ExpressionValueRenderer el={this.ruleData!.value1!} />
                    </BracketedDiv>
                    <ExpressionPiece>is email</ExpressionPiece>
                </ExpressionPiece>
            </>
        );
    }
}
